<template>
<div class="chapter">
<div class="inner_page">
<p class="western2" id="calibre_pb_0"> <br class="calibre1"/></p>
<p class="c1"><img alt="tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1_html_mac6eb93.jpg" class="calibre3" id="Picture_33" src="tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1_html_mac6eb93.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_001.vue?15ef01b4